export default "__VITE_ASSET__D7CB3ikA__"